import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSignup } from "../../hooks/useSignup";
import { useLogin } from "../../hooks/useLogin";
import Numetrics from "../../assets/numetrics.svg";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [formError, setFormError] = useState(null);
  const { signup, error, ssoProviderId, checkEmail } = useSignup();
  const {
    continueWithSso,
    completeSsoRedirect,
    error: ssoError,
    isPending: ssoPending,
  } = useLogin();
  const navigate = useNavigate();

  // "Continue" below leaves from this page, so the district sign-in returns
  // here; land where a password login lands.
  useEffect(() => {
    completeSsoRedirect().then((success) => {
      if (success) navigate("/");
    });
    // Once per page load; getRedirectResult yields a result only once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(null);

    if (!verifyEmail) {
      setFormError("invalid email format");
      return;
    }
    signup(email, password, displayName, firstName, lastName);
     };
  const regex = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
  const verifyEmail = regex.test(email);

  return (
    <div>
      <>
        <div className="min-h-full flex bg-slate-50 items-center align-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-lg w-full space-y-8 shadow-lg border-b-2">
            <div className="px-5 pb-12">
              <h2 className="mt-6 text-center text-3xl font-extrabold text-zinc-700">
                Sign up for a new account
              </h2>
              <p className="mt-2 text-center text-sm text-gray-600">
              Need help signing up? {' '}
              <a href="mailto:support@numetrics.org" className="font-medium text-indigo-600 hover:text-indigo-500">
                contact support@numetrics.org
              </a>
            </p>
              <div className="mt-5 col-span-2">
                {ssoProviderId ? (
                  <div className="mt-8 space-y-6">
                    <p className="text-sm text-gray-600">
                      Your district uses single sign-on.
                    </p>
                    <div className="pt-6">
                      <button
                        type="button"
                        disabled={ssoPending}
                        onClick={() =>
                          continueWithSso(ssoProviderId).then((ok) => {
                            if (ok) navigate("/");
                          })
                        }
                        className="group relative w-1/4 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                ) : (
                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                  <div className="grid grid-cols-8 gap-6">
                    <div className="col-span-4">
                      <label
                        htmlFor="first-name"
                        className="block text-sm font-medium text-gray-700"
                      >
                        First name
                      </label>
                      <input
                      required
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                        type="text"
                        name="first-name"
                        id="first-name"
                        autoComplete="given-name"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="col-span-4">
                      <label
                        htmlFor="last-name"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Last name
                      </label>
                      <input
                      required
                        type="text"
                        name="last-name"
                        id="last-name"
                        onChange={(e) => setLastName(e.target.value)}
                        value={lastName}
                        autoComplete="family-name"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="col-span-8">
                      <label
                        htmlFor="job-title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Job Title
                      </label>
                      <input

                        required
                        type="text"
                        onChange={(e) => setDisplayName(e.target.value)}
                        value={displayName}
                        name="job-title"
                        id="job-title"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="col-span-5">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <input
                        required
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        name="email"
                        id="email"
                        autoComplete="email"
                        onBlur={() => {
                          if (!verifyEmail) return setFormError("invalid email format");
                          setFormError(null);
                          checkEmail(email);
                        }}
                        onFocus={() =>

                            setFormError(null)

                        }
                        className={
                          formError
                            ? "border-red-300 border-2 mt-1 block w-full rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            : "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        }
                      />
                    </div>
                    {formError && (
                      <div className="col-span-2 -ml-6 rounded-r-sm w-[180px] h-17  bg-red-50 items-center flex border-r-4 border-red-200">
                        <div className="-ml-3 h-0 w-0 border-y-8 border-y-transparent border-r-[12px] border-r-red-50"></div>
                        <div className="pl-2 flex-row gap-2 text-red-600 font-semibold items-center flex">
                        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-6 h-6 text-red-500">
  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clipRule="evenodd" />
</svg></div>
                          {formError}
                        </div>
                      </div>
                    )}
                    <div className="col-span-5">
                      <label
                        htmlFor="email-address"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Password
                      </label>
                      <input
                        required
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        name="email-address"
                        id="email-address"
                        autoComplete="email"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  <div className="pt-6">
                    <button
                      type="submit"
                      className="group relative w-1/4 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >

                      Sign up
                    </button>
                  </div>
                </form>
                )}
              </div>    {(error || ssoError) &&

              <div className="bg-red-50/60 w-full flex flex-row items-center border-l-2 border-red-400 text-red-600 my-4 px-3 py-3 rounded-r-md relative gap-2 font-medium" role="alert"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-6 h-6 text-red-500 row-span-2">

  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clipRule="evenodd" />
</svg></div>

<span>{error || ssoError}</span></div>

}
            </div>
          </div>
        </div>{" "}
        <div className="pt-4">
          {" "}
          <img
            className="h-[20px] mx-auto w-auto"
            src={Numetrics}
            alt="NuMetrics"
          />
        </div>
      </>
    </div>
  );
}
